import { Controller } from "@hotwired/stimulus";
import Scroller from "@sveltejs/svelte-scroller";

export default class extends Controller {
  static targets = ["background", "foreground"];

  connect() {
    const background = document.createElement("div");
    const foreground = document.createElement("div");

    background.innerHTML = this.backgroundTarget.outerHTML;
    foreground.innerHTML = this.foregroundTarget.outerHTML;

    this.element.innerHTML = "";

    this.scroller = new Scroller({
      target: this.element,
      // data: { top: 0, bottom: 1 },
      threshold: 0,
      slots: {
        background,
        foreground,
      },
    });

    this.currentImage = 0;
    this.bgs = this.element.querySelectorAll(
      ".bg"
    );
  }

  disconnect() {
    this.scroller.destroy();
  }

  update() {
    let i = Math.max(this.scroller.get().index, 0);

    if (i !== this.currentImage) {
      this.bgs[this.currentImage].classList.remove("active");
      this.bgs[i].classList.add("active");
      this.currentImage = i;
    }
  }
}
